import { useSelector } from "react-redux";

import React, { useEffect, useState } from "react";

import { canRenderComponent } from "../../utils/common";

import { COMPONENTS } from "../../constants/component";
import UsersList from "../../components/Table/UsersList";

const AdminUser = () => {
  const authorizedComponent = useSelector(
    (state) => state.authentication.authorized_components
  );
  const [authorizedUserList, setAuthorizedUserList] = useState(
    canRenderComponent(COMPONENTS.USER_DISPLAY)
  );

  useEffect(() => {
    return () => {
      setAuthorizedUserList(canRenderComponent(COMPONENTS.USER_DISPLAY));
    };
  }, [authorizedComponent]);

  return authorizedUserList && <UsersList />;
};
export default AdminUser;
